import { useState } from 'react'
import { api } from '../api/client'

export default function SendEmailModal({ initial, onClose }: {
    initial: { contactId?: string, prospectId?: string, to: string, subject?: string, body?: string }
    onClose: () => void
}) {
    const [to, setTo] = useState(initial.to)
    const [subject, setSubject] = useState(initial.subject ?? '')
    const [body, setBody] = useState(initial.body ?? '')
    const [busy, setBusy] = useState(false)
    const [msg, setMsg] = useState<string | null>(null)

    async function send() {
        if (!to || !subject) return
        setBusy(true); setMsg(null)
        try {
            const resp: any = await api('/api/email/send', {
                method: 'POST',
                body: JSON.stringify({
                    contactId: initial.contactId, prospectId: initial.prospectId,
                    to, subject, body, bodyIsHtml: false
                })
            })
            setMsg(`Sent. Tracking ID: ${resp.trackingId?.slice(0, 8)}...`)
        } catch (e: any) {
            if (e.body?.blocked) setMsg('Blocked: contact has unsubscribed.')
            else setMsg(`Error: ${e.message}`)
        }
        finally { setBusy(false) }
    }

    return (
        <div style={overlay} onClick={onClose}>
            <div style={modal} onClick={e => e.stopPropagation()}>
                <h2>Send Email</h2>
                <div className="form-row">
                    <label>To</label>
                    <input value={to} onChange={e => setTo(e.target.value)} type="email" required data-testid="send-to" />
                </div>
                <div className="form-row">
                    <label>Subject</label>
                    <input value={subject} onChange={e => setSubject(e.target.value)} required data-testid="send-subject" />
                </div>
                <div className="form-row">
                    <label>Body</label>
                    <textarea value={body} onChange={e => setBody(e.target.value)} style={{ minHeight: 200 }} data-testid="send-body" />
                </div>
                {msg && <div className={msg.startsWith('Error') || msg.startsWith('Blocked') ? 'error' : 'success'}>{msg}</div>}
                <div className="row">
                    <button onClick={send} disabled={busy || !to || !subject} data-testid="send-email">Send</button>
                    <button className="secondary" onClick={onClose}>Close</button>
                </div>
            </div>
        </div>
    )
}

const overlay: React.CSSProperties = {
    position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)',
    display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100
}
const modal: React.CSSProperties = {
    background: '#fff', borderRadius: 6, padding: 24, width: 600, maxWidth: '90vw', maxHeight: '90vh', overflow: 'auto'
}
